/* Carousel.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["displayCarousel", "isLastSection"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["displayCarousel"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["active"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["displayCarousel"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _61 = "._1e0c1ule{display:block}";
const _60 = "._tdrqpxbi:focus-visible{margin-top:var(--ds-space-200,1pc)}";
const _59 = "._19lvkb7n:focus-visible{opacity:1}";
const _58 = "._146g1wug:focus-visible{height:auto}";
const _57 = "._1ejj1cd0:focus-visible{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _56 = "._hx7m1pyq:focus-visible{padding:var(--ds-space-100,8px) var(--ds-space-200,1pc)}";
const _55 = "._1gly1wug:focus-visible{margin-left:auto}";
const _54 = "._1wsjidpf:focus-visible{margin-bottom:0}";
const _53 = "._1nft1wug:focus-visible{margin-right:auto}";
const _52 = "._tdrqidpf:focus-visible{margin-top:0}";
const _51 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _50 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _49 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _48 = "._1ygbi3y1:focus-visible{outline:var(--ds-space-025,2px) solid var(--ds-border-focused,#388bff)}";
const _47 = "._tzy4idpf{opacity:0}";
const _46 = "._4t3iidpf{height:0}";
const _45 = "._bfhk18uv{background-color:initial}";
const _44 = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const _43 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _42 = "._y3gn1h6o{text-align:center}";
const _41 = "._syaz14q2{color:var(--ds-link,#0c66e4)}";
const _40 = "@media not all and (min-width:64rem){._1mjbglyw{display:none}}";
const _39 = "._1xi2idpf{right:0}";
const _38 = "._94n5idpf{bottom:0}";
const _37 = "._kqswstnw{position:absolute}";
const _36 = "._4cvr1h6o{align-items:center}";
const _35 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _34 = "._bfhk1oju{background-color:var(--ds-icon-subtle,#626f86)}";
const _33 = "._bfhk1qo3{background-color:var(--ds-icon-selected,#0c66e4)}";
const _32 = "._1e0c1o8l{display:inline-block}";
const _31 = "._80omtlke{cursor:pointer}";
const _30 = "._4t3iu2gc{height:var(--ds-space-100,8px)}";
const _29 = "._1bsbu2gc{width:var(--ds-space-100,8px)}";
const _28 = "._19itglyw{border:none}";
const _27 = "._19bvidpf{padding-left:0}";
const _26 = "._n3tdidpf{padding-bottom:0}";
const _25 = "._u5f3idpf{padding-right:0}";
const _24 = "._ca0qidpf{padding-top:0}";
const _23 = "._18s8otz2{margin:0 var(--ds-space-050,4px)}";
const _22 = "._2rko1ssb{border-radius:50%}";
const _21 = "._1e0cglyw{display:none}";
const _20 = "._1e0c1txw{display:flex}";
const _19 = "@media not all and (min-width:64rem){._1mjbglyw{display:none}._3wvkidpf{margin-top:0}}";
const _18 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _17 = "._1bah1h6o{justify-content:center}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { BodyNormal } from '@atlassian/mpac-primitives';
import { useCallback, useRef, useState } from 'react';
import { collections } from './constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _16 = "@media (min-width:64rem){._1ivaidpf{border-left:0}}";
const _15 = "@media (min-width:64rem){._1iva176a{border-left:var(--ds-space-025,2px) solid var(--ds-border,#091e4224)}}";
const _14 = "@media (min-width:64rem){._ew7kidpf{border-right:0}}";
const _13 = "@media (min-width:64rem){._ew7k176a{border-right:var(--ds-space-025,2px) solid var(--ds-border,#091e4224)}}";
const _12 = "@media (min-width:64rem){._1hvkidpf{margin-right:0}}";
const _11 = "@media (min-width:64rem){._1hvkmgjw{margin-right:var(--ds-space-negative-200,-1pc)}}";
const _10 = "@media (min-width:64rem){._15qmidpf{margin-left:0}}";
const _9 = "@media (min-width:64rem){._15qmmgjw{margin-left:var(--ds-space-negative-200,-1pc)}}";
const _8 = "@media (min-width:64rem){._1rmjidpf{padding-right:0}}";
const _7 = "@media (min-width:64rem){._1rmjpxbi{padding-right:var(--ds-space-200,1pc)}}";
const _6 = "@media (min-width:64rem){._pnmbidpf{padding-left:0}}";
const _5 = "@media (min-width:64rem){._pnmbpxbi{padding-left:var(--ds-space-200,1pc)}}";
const _4 = "@media (min-width:64rem){._zp81ewfl{overflow-x:visible}._1mbpewfl{overflow-y:visible}}";
const _3 = "@media (min-width:64rem){._zp8115vq{overflow-x:hidden}._1mbp15vq{overflow-y:hidden}}";
const _2 = "@media (min-width:64rem){._cjbtpxbi{padding-bottom:var(--ds-space-200,1pc)}._oqicpxbi{padding-top:var(--ds-space-200,1pc)}._dbjgmgjw{margin-top:var(--ds-space-negative-200,-1pc)}._isu4mgjw{margin-bottom:var(--ds-space-negative-200,-1pc)}}";
const _ = "@media (min-width:64rem){}";
export const CarouselContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      displayCarousel,
      isLastSection
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_cjbtpxbi _oqicpxbi _dbjgmgjw _isu4mgjw", __cmplp.displayCarousel ? "_zp8115vq _1mbp15vq" : "_zp81ewfl _1mbpewfl", !__cmplp.isLastSection && __cmplp.displayCarousel ? "_pnmbpxbi" : "_pnmbidpf", __cmplp.isLastSection && __cmplp.displayCarousel ? "_1rmjpxbi" : "_1rmjidpf", !__cmplp.isLastSection && __cmplp.displayCarousel ? "_15qmmgjw" : "_15qmidpf", __cmplp.isLastSection && __cmplp.displayCarousel ? "_1hvkmgjw" : "_1hvkidpf", !__cmplp.isLastSection && __cmplp.displayCarousel ? "_ew7k176a" : "_ew7kidpf", __cmplp.isLastSection && __cmplp.displayCarousel ? "_1iva176a" : "_1ivaidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CarouselContainer.displayName = 'CarouselContainer';
}
export const PaginationDots = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17, _18, _19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bah1h6o _19pk1ejb _1mjbglyw _3wvkidpf", __cmplp.displayCarousel ? "_1e0c1txw" : "_1e0cglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PaginationDots.displayName = 'PaginationDots';
}
export const Dot = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded5);
  const {
      active
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko1ssb _18s8otz2 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _1bsbu2gc _4t3iu2gc _80omtlke _1e0c1o8l", __cmplp.active ? "_bfhk1qo3" : "_bfhk1oju", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Dot.displayName = 'Dot';
}
export const ArrowsContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_35, _20, _36, _37, _38, _39, _40]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _1e0c1txw _4cvr1h6o _kqswstnw _94n5idpf _1xi2idpf _1mjbglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ArrowsContainer.displayName = 'ArrowsContainer';
}
export const FocusButtonText = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_32, _41, _42, _43]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _syaz14q2 _y3gn1h6o _19pku2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FocusButtonText.displayName = 'FocusButtonText';
}
export const FocusButton = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded9);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_28, _44, _43, _45, _31, _42, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _40, _61, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _2rkou2gc _19pku2gc _bfhk18uv _80omtlke _y3gn1h6o _4t3iidpf _tzy4idpf _1ygbi3y1 _vjfr18uv _10xfglyw _1w0vnqa1 _tdrqidpf _1nft1wug _1wsjidpf _1gly1wug _hx7m1pyq _1ejj1cd0 _146g1wug _19lvkb7n _tdrqpxbi _1mjbglyw", __cmplp.displayCarousel ? "_1e0c1ule" : "_1e0cglyw", __cmplp.className])
    }))]
  });
});

// eslint-disable-next-line max-lines-per-function
if (process.env.NODE_ENV !== 'production') {
  FocusButton.displayName = 'FocusButton';
}
export const useCarouselNavigation = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerSection = 3;
  const totalSections = Math.ceil(collections.length / itemsPerSection);
  const isLastSection = currentIndex === totalSections - 1;
  const leftArrowRef = useRef(null);
  const focusButtonRef = useRef(null);
  const cardRefs = useRef([]);
  const handlePrev = useCallback(() => {
    if (currentIndex === 0) {
      setCurrentIndex(totalSections - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  }, [currentIndex]);
  const handleNext = useCallback(() => {
    const newIndex = currentIndex === totalSections - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, totalSections, setCurrentIndex]);
  const goToLeftArrowControl = useCallback(() => {
    if (leftArrowRef.current) {
      leftArrowRef.current.focus();
    }
  }, [leftArrowRef]);
  const handleRightArrowKeyDown = useCallback(event => {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      const firstCardInSection = currentIndex * itemsPerSection;
      const cardToFocus = cardRefs.current[firstCardInSection];
      if (cardToFocus && typeof cardToFocus.focus === 'function') {
        cardToFocus.focus();
      }
    }
  }, [currentIndex, itemsPerSection, handleNext, cardRefs, handlePrev]);
  const handleFocusButtonPress = useCallback(event => {
    if ((event.key === 'Enter' || event.key === 'Spacebar') && !event.shiftKey) {
      event.preventDefault();
      goToLeftArrowControl();
    }
  }, [goToLeftArrowControl]);
  return {
    currentIndex,
    itemsPerSection,
    setCurrentIndex,
    totalSections,
    isLastSection,
    handlePrev,
    handleNext,
    handleRightArrowKeyDown,
    goToLeftArrowControl,
    handleFocusButtonPress,
    leftArrowRef,
    focusButtonRef,
    cardRefs
  };
};